import React, { Component } from 'react';
import Editable from '../Editable/Editable';
import IV from '../InputValidation/InputValidation';
import Markets from '../Industry/Industry';
import ICompanyHeader, { TCompanyHeader } from './ICompanyHeader';
import ImageUploader from '../ImageUploader/ImageUploader';
import FollowCompany from '../FollowCompany/FollowCompany';
import AsyncImage from '@appComponents/AsyncImage/AsyncImage';
import noPhotoCompany from '@images/no_photo_company.png';

import * as styles from './CompanyHeaderStyles.module.scss';

class CompanyHeader extends Component<ICompanyHeader, TCompanyHeader> {

  state: TCompanyHeader = {
    data: {
      name: this.props.name,
      legal_name: this.props.legal_name,
    },
  };

  UNSAFE_componentWillReceiveProps(nextProps: ICompanyHeader) {
    this.setState({
      data: {
        name: nextProps.name,
        legal_name: nextProps.legal_name,
      },
    });
  }

  componentDidUpdate(prevProps: ICompanyHeader, prevState: TCompanyHeader) {
    if (this.props.editMode) {
      if (prevState.data.name !== this.state.data.name) {
        this.props.updateStateFromChild('name', this.state.data.name);
      }

      if (prevState.data.legal_name !== this.state.data.legal_name) {
        this.props.updateStateFromChild('legal_name', this.state.data.legal_name);
      }
    }
  }

  removeAvatar = () => {
    if (confirm('Are you sure?')) {
      this.props.getImageId({ id: null, url: null, to_delete_id: this.props.logo.id });
    }
  }

  displayEdit() {
    return (
      <div className={styles.headerEdit}>
        <div className={styles.headerLogo}>
          <div className={styles.bordered}>
            <ImageUploader
              getImageId={this.props.getImageId}
              type="avatar"
              avatar={this.props.logo.url ? this.props.logo.url : noPhotoCompany}
              loaderFullWidth={true}
              uploadSizeLimit={5}
            />
          </div>
          {this.props.logo.url &&
            <button className={styles.removeAvatar} onClick={this.removeAvatar}>
              <span className="fa fa-times"/> Remove Avatar
            </button>
          }
        </div>
        <div className={styles.right}>
          <div className={styles.headerEditHeadline}>
            <h1>
              <IV type="noEmpty" dispatch={this.props.dispatch}>
                <Editable type="input" _this={this} name="name" />
              </IV>
            </h1>
            <h2 className={styles.legalName}>
              <IV type="" dispatch={this.props.dispatch}>
                <Editable ph="Company Legal Name" type="input" _this={this} name="legal_name" />
              </IV>
            </h2>
          </div>
          <Markets
            industries={this.props.markets}
            markets={true}
            editMode={true}
            updateStateFromChild={this.props.updateStateFromChild}
          />
        </div>
      </div>
    );
  }

  display() {
    return (
      <div className={styles.header}>
        <div className={styles.headerLogo}>
          <AsyncImage image={this.props.logo.url} fallback={noPhotoCompany}>
            <img />
          </AsyncImage>
        </div>
        <FollowCompany
          companyId={this.props.companyID}
          name={this.props.name}
          followers={this.props.totalFollowers}
          userSignedIn={this.props.userSignedIn}
          isOwner={this.props.isOwner}
          isCreator={this.props.isCreator}
        />
      </div>
    );
  }

  render() {
    return this.props.editMode ? this.displayEdit() : this.display();
  }
}

export default CompanyHeader;
